// 📁 src/contexts/UserContext.js
import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    axios
      .get("https:api.remindly.gr/auth-check.php", { withCredentials: true })
      .then((res) => {
        setUser(res.data.user);
      })
      .catch(() => {
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const logout = async () => {
    await axios.post("https:api.remindly.gr/logout.php", {}, { withCredentials: true });
    setUser(null);
  };

  // 👇 ΑΥΤΟ εδώ κρατά το app παγωμένο μέχρι να φορτωθεί ο χρήστης
  if (loading) {
    return <div className="text-center mt-10">🔐 Έλεγχος πρόσβασης...</div>;
  }

  return (
    <UserContext.Provider value={{ user, setUser, loading, logout }}>
      {children}
    </UserContext.Provider>
  );
};


export const useUser = () => useContext(UserContext);
